/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_BodyInputs */

const en_svc_research_scope_body = /** @type {(inputs: Svc_Research_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A research agent works through a question the way an analyst would: search, read, compare, check, and write it up. We keep the question and the sources it may use agreed, so the result is predictable and easy to check.`)
};

const lv_svc_research_scope_body = /** @type {(inputs: Svc_Research_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpētes aģents strādā ar jautājumu kā analītiķis: meklē, lasa, salīdzina, pārbauda un apkopo. Jautājums un avoti, ko tas drīkst izmantot, ir saskaņoti, tāpēc rezultāts ir paredzams un viegli pārbaudāms.`)
};

/**
* | output |
* | --- |
* | "A research agent works through a question the way an analyst would: search, read, compare, check, and write it up. We keep the question and the sources it ma..." |
*
* @param {Svc_Research_Scope_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_body = /** @type {((inputs?: Svc_Research_Scope_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_body(inputs)
	return en_svc_research_scope_body(inputs)
});